



































import { Vue, Component } from 'vue-property-decorator'
import store from '@/store'
import { Card } from '@alpha/ink'
import LiveCharts from '@/components/Survey/LiveCharts.vue'
import TestOverview from '@/components/SharedResults/TestOverview.vue'
import LoadingIndicator from '@/components/LoadingIndicator.vue'
import PageHeader from '@/components/PageHeader.vue'
import AnimatedContainer from '@/components/AnimatedContainer.vue'
import TestDetailsFooter from '@/components/TestDetails/TestDetailsFooter.vue'

@Component({
  components: {
    TestDetailsFooter,
    LiveCharts,
    Card,
    TestOverview,
    LoadingIndicator,
    PageHeader,
    AnimatedContainer
  }
})
export default class SharedResults extends Vue {
  loaded: boolean = false

  async mounted () {
    const { sharedLinkHash } = this.$route.params
    try {
      await store.dispatch.surveyConfiguration.fetchTestConfigurationsWithMeta({ sharedLinkHash })
      await store.dispatch.survey.fetchSurvey({
        workspaceId: store.state.surveyConfiguration.workspaceId!,
        testId: store.state.surveyConfiguration.testId!,
        sharedLinkHash
      })
      this.loaded = true
    } catch (e) {
      store.dispatch.setErrorMessage({
        header: 'Report Unavailable',
        body: 'This link has been disabled by a Feedback Loop user.'
      })
      console.error(e)
    }
  }

  get workspaceIcon () {
    return store.state.surveyConfiguration.testMetaDetails?.workspaceIcon
  }

  get metaDetails () {
    return store.state.surveyConfiguration.testMetaDetails
  }

  get testTitle () {
    return this.metaDetails?.title
  }
}
